import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from '~gql';

// Web analog of the app's widgets/continue_with/_shared.dart: the session
// shape every sign-in method resolves to, and the shared error mapping.

export const SESSION_USER = graphql(`
  fragment SessionUser on User {
    id
    username
    deleteAt
    hasFinishedOnboarding
    email {
      value
    }
  }
`);

export type SessionUser = ResultOf<typeof SESSION_USER>;

export type AuthSession = {
  token: string;
  user: SessionUser;
};

export const authErrorMessage = (err: unknown): string => {
  const shaped = err as {
    errors?: Array<{ extensions?: { code?: string } }>;
    graphQLErrors?: Array<{ extensions?: { code?: string } }>;
  };
  const code = (shaped.errors ?? shaped.graphQLErrors)?.[0]?.extensions?.code;
  switch (code) {
    case 'INVALID_CREDENTIALS':
      return 'Those details don’t match an account. Check them and try again.';
    case 'MISSING_PASSWORD':
      return 'This account signs in with Apple or Google — use one of the buttons above.';
    case 'RATE_LIMITED':
      return 'Too many attempts. Please wait a few minutes and try again.';
    case 'OAUTH_ERROR':
      return 'Sign-in failed. Please try again.';
    default:
      return 'Something went wrong. Please try again.';
  }
};
